import axiosInstance from "../axios/axios_instance"
const http = axiosInstance("/protected",  null, "/dashboard")


const getPeople = (id) => http.get("/people/" + id);
const getPeopleFromSurvey = (team_id, survey_id) => http.get("/people/" + team_id + "/" + survey_id);
const newPerson = (body) => http.post("/people", body);
const updatePeople = (team_id, organisation_id, people, deletedPeople) => http.put("/people", {
    "team_id": team_id,
    "organisation_id": organisation_id,
    "people": people,
    "deleted_people": deletedPeople
});
const deletePerson = (id) => http.delete("/people/" + id)
const getDemoPeople = (id) => http.get(`/demo_people/${id}`);
const getDemoPeopleFromSurvey = (id, survey_id) => http.get(`/demo_people/${id}/${survey_id}`);

export default {
    getPeople,
    getPeopleFromSurvey,
    newPerson,
    updatePeople,
    deletePerson,
    getDemoPeople,
    getDemoPeopleFromSurvey
}